export default "__VITE_ASSET__CAeSv$Dc__"